if (!customElements.get('selling-plan-selector')) {
  class SellingPlanSelector extends HTMLElement {
    constructor() {
      super();
      this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
      this.sellingPlanRadioButtons = this.querySelectorAll('input[type="radio"]');
    }

    connectedCallback() {
      this.sellingPlanRadioButtons.forEach((radio) => {
        radio.addEventListener('change', (event) => {
          this.sellingPlanInput.value = event.target.dataset.sellingPlanId;
        });
      });
    }
  }

  customElements.define('selling-plan-selector', SellingPlanSelector);
}
